module.exports = __webpack_public_path__ + "img/arrow-bar-left.8111f827.svg";